import React from "react";
import { ChevronLeft, ChevronRight, Trophy, Loader2 } from "lucide-react";

/**
 * TestFooter
 * Sticky Previous / Next / Submit bar plus a live "N of M answered" readout
 * and a compact keyboard-shortcut hint (hidden on small screens).
 */
const TestFooter = ({
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext,
  isLastQuestion,
  onSubmit,
  submitting,
  answeredCount,
  totalQuestions,
}) => {
  return (
    <footer className="test-footer">
      <button
        type="button"
        className="footer-btn"
        onClick={onPrevious}
        disabled={!canGoPrevious}
      >
        <ChevronLeft />
        <span>Previous</span>
      </button>

      <div className="footer-center">
        <span className="footer-progress-text">
          {answeredCount} / {totalQuestions} answered
        </span>
        <span className="footer-hint">
          <span>
            <kbd>←</kbd>
            <kbd>→</kbd>navigate
          </span>
          <span>
            <kbd>1-9</kbd>rate
          </span>
          <span>
            <kbd>↵</kbd>continue
          </span>
        </span>
      </div>

      {isLastQuestion ? (
        <button
          type="button"
          className="footer-btn submit"
          onClick={onSubmit}
          disabled={submitting}
        >
          {submitting ? <Loader2 className="spin" /> : <Trophy />}
          <span>{submitting ? "Submitting…" : "Submit"}</span>
        </button>
      ) : (
        <button
          type="button"
          className="footer-btn primary"
          onClick={onNext}
          disabled={!canGoNext}
        >
          <span>Next</span>
          <ChevronRight />
        </button>
      )}
    </footer>
  );
};

export default TestFooter;
